var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStageFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.4,
    y: 3.6,
    width: 3.6,
    height: 16.8,
    rx: 1.8,
    stroke: "#595959",
    strokeWidth: 1.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 3.6,
    width: 3.6,
    height: 16.8,
    rx: 1.8,
    fill: "#595959"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 3.6,
    width: 3.6,
    height: 16.8,
    rx: 1.8,
    stroke: "#595959",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStageFilter);
export default __webpack_public_path__ + "static/media/stage-filter.ded7b0dcf1e0a1c049fa719774e71a2a.svg";
export { ForwardRef as ReactComponent };